import dayjs from "dayjs";

const statusList: any = {
  0: "Draft",
  1: "Open",
  2: "Re-Verify",
  3: "Yacht Verified",
  4: "Audit",
  50: "Pending Audit",
  200: "Internal Audit Verified",
  210: "Superintendent Visit Verified",
  220: "Manager Visit Verified",
  230: "Periodic Inspection Verified",
  240: "Management Review",
  250: "Yacht Review",
  1000: "Audit",
  5: "Further Info Requested",
  6: "Further Info Provided",
  99: "Withdrawn",
};

export const mapReviewReport = (res: any) => {
  const data = res.data;
  if (!data) return;
  const type = statusList[data.audittype];
  const date = data.auditdate;
  const sigtype = data.audittype === 1000 ? "AUDITOR" : "REVIEWER";
  let comments: any = [];
  let entries: any = [];

  if (data.comments && data.comments.length > 0) {
    comments = data.comments.map((c: any) => ({
      header:
        (c.role ? c.role + " - " : "") +
        c.fname +
        " " +
        c.sname +
        "   " +
        dayjs(c.date).format("D MMM YYYY HH:mm"),
      content: c.message,
    }));
  }

  let reviewer = data.reviewer?.flag ?? "";
  reviewer += data.reviewer?.role ?? "";
  if (reviewer) reviewer += " - ";
  reviewer += data.reviewer?.name ?? "";

  if (data.result && data.result.length > 0) {
    entries = data.result
      .filter((r: any) => r !== false && r !== null)
      .map((r: any) => {
        const status = statusList[r.status];
        const date = dayjs(r.datecreated).format("D MMM YYYY - HH:mm");
        let comments = [];
        if (r.reverify && r.reverify.length > 0) {
          comments = r.reverify.map((c: any) => ({
            header:
              (c.role ? c.role + " - " : "") +
              c.fname +
              " " +
              c.sname +
              "   " +
              dayjs(c.date).format("D MMM YYYY - HH:mm"),
            content: c.message,
          }));
        }

        return {
          ref: r.unum + " - " + r.enum,
          title: r.lbname,
          date,
          status,
          comments,
          partid: r.partid,
          lbeid: r.lbeid,
          meid: r.meid,
        };
      });
  }
  return {
    date,
    type,
    sigtype,
    comments,
    entries,
    reviewer,
    yachtuser: data.usertype !== 8 && data.usertype !== 9,
  };
};
